module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop7.8c82e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop7.jpg
// module id = oE3L
// module chunks = 0